import a_darker_shade from './img/a_darker_shade.jpg'
import a_game_of_thrones from './img/a_game_of_thrones.jpg'
import a_wizard_of_eaarthsea from './img/a_wizard_of_eaarthsea.jpg'
import circe from './img/circe.jpg'
import dragonflight from './img/dragonflight.jpg'
import dube from './img/dube.jpg'
import gardens_of_the_moon from './img/gardens_of_the_moon.jpg'
import good_omens from './img/good_omens.jpg'
import harry_potter from './img/harry_potter.jpg'
import jonathan_strange from './img/jonathan_strange.jpg'
import magician from './img/magician.jpg'
import neil_gaiman from './img/neil_gaiman.jpg'
import neverwhere from './img/neverwhere.jpg'
import prince_of_thorns from './img/prince_of_thorns.jpg'
import the_chronicles_of from './img/the_chronicles_of.jpg'
import the_dark_is_rising from './img/the_dark_is_rising.jpg'
import the_eye_of_the_world from './img/the_eye_of_the_world.jpg'
import the_fifth_season from './img/the_fifth_season.jpg'
import the_gentlemen from './img/the_gentlemen.jpg'
import the_golden_compass from './img/the_golden_compass.jpg'
import the_last_unicorn from './img/the_last_unicorn.jpg'
import where_the_mountain from './img/where_the_mountain.jpg'
import who_fears_death from './img/who_fears_death.jpg'
import wizards_first_rule from './img/wizards_first_rule.jpg'


export const FABookItems = [
  {
    id:1501,
    title:"A Darker Shade of Magic",
    image: a_darker_shade,
    price:1449,
    
  },
  {
    id:1502,
    title:"A Game of Thrones",
    image: a_game_of_thrones,
    price:499,
    
  },
  {
    id:1503,
    title:"A Wizard of EarthSea",
    image: a_wizard_of_eaarthsea,
    price:1159,
    
  },
  {
    id:1504,
    title:"Circe",
    image: circe,
    price:1859,
    
  },
  {
    id:1505,
    title:"Dragon Flight",
    image: dragonflight,
    price:1129,
    
  },
  {
    id:1506,
    title:"Dune",
    image: dube,
    price:1319,
    
  },
  {
    id:1507,
    title:"Gardens of the Moon",
    image: gardens_of_the_moon,
    price:799,
    
  },
  {
    id:1508,
    title:"Good Omens",
    image: good_omens,
    price:629,
    
  },
  {
    id:1509,
    title:"Harry Potter",
    image: harry_potter,
    price:2669,
    
  },
  {
    id:1510,
    title:"Jonathan Strange",
    image: jonathan_strange,
    price:4399,
    
  },
  {
    id:1511,
    title:"Magician",
    image: magician,
    price:1639,
    
  },
  {
    id:1512,
    title:"American Gods",
    image: neil_gaiman,
    price:3899,
    
  },
  {
    id:1513,
    price:699,
    title: "Neverwhere",
    image: neverwhere,
    
  },
  {
    id:1514,
    price:399,
    title: "Prince of Thorns",
    image: prince_of_thorns,
   
  },
  {id:1515,
    price:1199,
    title: "The Chronicles of Narnia",
    image: the_chronicles_of,
    
  },
  {
    id:1516,
    price:4489,
    title: "The Dark is Rising",
    image: the_dark_is_rising,
    
  },
  {
    id:1517,
    price:599,
    title: "The Eye of the World",
    image: the_eye_of_the_world,
    
  },
  {
    id:1518,
    price:1959,
    title: "The Fifth Season",
    image: the_fifth_season,
    
  },
  {
    id:1519,
    price:499,
    title: "The Gentlemen Bastards",
    image: the_gentlemen,
    
  },
  {
    id:1520,
    price:1399,
    title: "The Golden Compass",
    image: the_golden_compass,
    
  },
  {
    id:1521,
    price:40999,
    title: "The Last Unicorn",
    image: the_last_unicorn,
    
  },
  {
    id:1522,
    price:1199,
    title: "Where the Mountain Meets the Moon",
    image:where_the_mountain,    
  },
  {
    id:1523,
    price:619,
    title: "Who Fears Death",
    image: who_fears_death,
    
  },
  {
    id:1524,
    price:2799,
    title: "Wizard's First Rule",
    image: wizards_first_rule,
    
  },
  
];